
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const AddAppointment = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g stroke="none" fill="none" className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M9.28123711,3 L9.28123711,5.44252874 L15.7587629,5.44252874 L15.7587629,3 L17.2309278,3 L17.2309278,5.44252874 L22.04,5.44252874 L22.04,19.6091954 C22.04,21.3284362 20.6882353,22.733381 18.9850234,22.8282295 L18.8012371,22.8333333 L3,22.8333333 L3,5.44252874 L7.80907216,5.44252874 L7.80907216,3 L9.28123711,3 Z M7.80907216,6.90804598 L4.47216495,6.90804598 L4.47216495,21.3678161 L18.8012371,21.3678161 C19.269768,21.3678161 19.7191091,21.1825334 20.0504105,20.852728 C20.3402992,20.5641483 20.5190358,20.1856026 20.5591905,19.7830134 L20.5678351,19.6091954 L20.5678351,6.90804598 L17.2309278,6.90804598 L17.2309278,8.66666667 L15.7587629,8.66666667 L15.7587629,6.90804598 L9.28123711,6.90804598 L9.28123711,8.66666667 L7.80907216,8.66666667 L7.80907216,6.90804598 Z M13.1760815,9.74137931 L13.1760815,13.6494253 L17.0037104,13.6494253 L17.0037104,15.1149425 L13.1760815,15.1149425 L13.1760815,18.9252874 L11.7039165,18.9252874 L11.7039165,15.1149425 L7.77814334,15.1149425 L7.77814334,13.6494253 L11.7039165,13.6494253 L11.7039165,9.74137931 L13.1760815,9.74137931 Z"
            id="Recommended-Appointment-Icon"></path>
        </g>
      </g>
    </IconBase>);
};

AddAppointment.defaultProps = {
  title: 'Add Appointment',
};

export default AddAppointment;
